<template>
  <div
    class="modal fade modal-signUp"
    id="signupModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="signupModalLabel"
    aria-hidden="true"
  >
    <div class="container">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="row align-items-stretch no-gutters">
            <div class="col-md-5">
              <div class="modal-login__col"></div>
            </div>
            <div class="col-md-7 d-flex flex-column">
              <div class="modal-header">
                <h4>{{ $t("signUp") }}</h4>
                <a
                  href="#"
                  class="icon icon-cross"
                  data-dismiss="modal"
                  aria-label="Close"
                  >{{ $t("close") }}</a
                >
              </div>
              <div class="modal-body pb-0">
                <div class="w-100">
                  <div class="tabs tabs_gray">
                    <div
                      class="tabs__tab cursor-pointer"
                      :class="{
                        tabs__tab_active: clientType === 1,
                        tabs__tab_disabled: clientType > 1,
                      }"
                      @click="navigate"
                    >
                      {{ $t("personnalAccount") }}
                    </div>
                    <div
                      class="tabs__tab tabs__tab_disabled cursor-pointer"
                      :class="{
                        tabs__tab_active: clientType === 2,
                        tabs__tab_disabled: clientType < 1,
                      }"
                      @click="navigate"
                    >
                      {{ $t("companyAccount") }}
                    </div>
                  </div>
                  <div v-if="clientType === 2" is="Sign-up-company" />
                  <div v-if="clientType === 1" is="Sign-up-personal" />
                </div>
              </div>
              <div class="modal-login__footer mt-0 p-3">
                <div>{{ $t("alredyHaveAccount") }}</div>
                <div>
                  <a href="#" @click="openLogIn">{{ $t("connexion") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignUpCompany from "./SignUpCompany.vue";
import SignUpPersonal from "./SignUpPersonal.vue";
export default {
  name: "SignupModal",
  components: {
    "Sign-up-company": SignUpCompany,
    "Sign-up-personal": SignUpPersonal,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      password: null,
      confirmed: null,
      email: null,
      phone: null,
      companyName: "",
      legalForm: "",
      phone: "",
      companyEmail: "",
      country: "",
      tradeName: "",
      address: "",
      city: "",
      agent: false,
      siret: "",
      zipCode: "",
      subscribe: false,
      accepted: false,
      local: "",
      matchPassword: true,
      clientType: 1,
      monitor: {
        visible: false,
        message: "",
        type: "text-warning",
      },
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      if (this.$lodash.get(this.$route, "query", false)) {
        if (
          this.$lodash.get(this.$route.query, "token", false)
        ) {
          this.clientType = 2
        }
      }
    },
  },
  created() {
    this.local = document.head.querySelector('meta[name="app-locale"]').content;
  },
  mounted() {
    console.log('window.location.toString() :', window.location.toString())
    if (window.location.toString().includes('/#/?token=')) {
      this.clientType = 2
    }
  },
  methods: {
    openLogIn() {
      $("#loginModal").modal("show");
      $("#signupModal").modal("hide");
      $("body").css("overflow", "hidden");
    },
    nextCheck() {
      return (
        this.firstname &&
        this.lastname &&
        this.email &&
        this.phone &&
        this.password &&
        this.confirmed &&
        this.password === this.confirmed &&
        this.accepted
      );
    },

    navigate() {
      if (this.clientType === 1) {
        this.clientType = this.clientType + 1;
      } else if (this.clientType === 2) {
        this.clientType = this.clientType - 1;
      }
      return this.clientType;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
